export class AdUnitNote {
  id: string;
  adUnitId: string;
  note: string;
  user: string;
  createdOn: string;
}
